import { useState } from "react";
import "./contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    companyName: "",
    websiteUrl: "",
    marketingInvestment: [],
    serviceInterest: [],
    name: "",
    email: "",
    phone: "",
  });

  const marketingOptions = ["Less than $500", "$500 - $2000", "$2000 - $5000", "More than $5000"];
  const serviceOptions = ["Website Design", "Google Seo", "Google Maps"];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (category, value) => {
    setFormData((prevData) => {
      const updatedArray = prevData[category].includes(value)
        ? prevData[category].filter((item) => item !== value)
        : [...prevData[category], value];
      return { ...prevData, [category]: updatedArray };
    });
  };

  const sendMessage = () => {
    const message = `Company Name: ${formData.companyName}\nWebsite: ${formData.websiteUrl}\nMarketing Investment: ${formData.marketingInvestment.join(", ")}\nService Interest: ${formData.serviceInterest.join(", ")}\nName: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}`;
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = "918374294299"; // Replace with actual number
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
  };

  return (
    <>
    <div className="headpara">
    <h2 >Let us help you navigate the path to local search success!</h2>
    <p >Looking to reach the peak of local search rankings? Tell us how we can assist, 
        and our expert digital marketing team will connect with you within 24 hours!</p>
    </div>
    <div className="contact-container">
      <label>Company Name</label>
      <input className="text-input" name="companyName" value={formData.companyName} onChange={handleChange} />
      
      <label>Website URL</label>
      <input className="text-input" name="websiteUrl" value={formData.websiteUrl} onChange={handleChange} />
      
      <label>How much are you currently investing in marketing?</label>
      {marketingOptions.map((option) => (
        <div key={option} className="checkbox-group">
          <input type="checkbox" checked={formData.marketingInvestment.includes(option)} onChange={() => handleCheckboxChange("marketingInvestment", option)} />
          <span>{option}</span>
        </div>
      ))}
      
      <label>Service of Interest</label>
      {serviceOptions.map((option) => (
        <div key={option} className="checkbox-group">
          <input type="checkbox" checked={formData.serviceInterest.includes(option)} onChange={() => handleCheckboxChange("serviceInterest", option)} />
          <span>{option}</span>
        </div>
      ))}
      
      <label>Your Name</label>
      <input className="text-input" name="name" value={formData.name} onChange={handleChange} />
      
      <label>Email ID</label>
      <input className="text-input" name="email" value={formData.email} onChange={handleChange} />
      
      <label>Phone Number</label>
      <input className="text-input" name="phone" value={formData.phone} onChange={handleChange} />
      
      <button className="contact-button" onClick={sendMessage}>Send Message</button>
    </div>
    </>
  );
}
